import { Link } from 'react-router-dom';
import { UserRole } from '@klaro7/shared-types';

import { useAuth } from '@/features/auth/hooks/useAuth';
import { useConfigStatus } from '../hooks/useServicesSettings';

/**
 * Red banner shown to super admins when one or more required runtime config
 * keys (DB feature flags) are missing. Clicking it jumps to the Feature Flags
 * section where the missing keys can be configured with suggestions.
 */
export function ConfigStatusBanner() {
  const { user } = useAuth();
  const isSuperAdmin = user?.role === UserRole.SUPER_ADMIN;
  const { data } = useConfigStatus(isSuperAdmin);

  if (!isSuperAdmin || !data) return null;

  const missing = data.filter((c) => c.required && !c.configured);
  if (missing.length === 0) return null;

  return (
    <Link
      to="/dashboard/admin/services?section=feature-flags"
      className="block bg-red-600 text-white transition-colors hover:bg-red-700"
    >
      <div className="mx-auto flex max-w-7xl items-start gap-3 px-4 py-2.5 lg:px-6">
        <svg className="mt-0.5 h-5 w-5 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
        </svg>
        <div className="text-sm">
          <span className="font-semibold">Configurazione incompleta — </span>
          {missing.length === 1
            ? 'manca una variabile di configurazione: '
            : `mancano ${missing.length} variabili di configurazione: `}
          <span className="font-semibold">{missing.map((m) => m.label).join(', ')}</span>
          <span className="ml-1 underline">Configura ora →</span>
        </div>
      </div>
    </Link>
  );
}
